import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, Typography, App } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import api from '@/api/client';
import { useAdminStore } from '@/stores/useAdminStore';

const { Title } = Typography;

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const setAuth = useAdminStore((s) => s.setAuth);
  const { message } = App.useApp();

  const handleLogin = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      console.log('开始登录请求', values.username);
      const response = await api.post('/auth/login', values);
      console.log('登录响应', response);
      const { data } = response;
      console.log('响应数据', data);
      if (data.token) {
        setAuth(data.token, data.admin);
        message.success('登录成功');
        navigate('/');
      } else {
        console.error('响应中没有token', data);
        message.error('登录响应格式错误');
      }
    } catch (err: any) {
      console.error('登录错误', err);
      console.error('错误响应', err.response);
      message.error(err.response?.data?.error || err.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' }}>
      <Card style={{ width: 400, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo.png" alt="Logo" style={{ width: 48, height: 48, borderRadius: 12, marginBottom: 16, objectFit: 'cover' }} />
          <Title level={3}>管理后台</Title>
          <Typography.Text type="secondary">超级产品经理</Typography.Text>
        </div>
        <Form onFinish={handleLogin} size="large">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined />} placeholder="用户名" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
